// extracted by mini-css-extract-plugin
module.exports = {"dbList":"j_8","dbList__db":"j_9","dbList__product":"j_bb"};